require('./jquery.scrollbar');
module.exports = 'jQueryScrollbar';




//////////////////
// WEBPACK FOOTER
// ./~/jquery.scrollbar/index.js
// module id = 665
// module chunks = 1